import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import DialogWindow from "./DialogWindow";
import CameraEventRepository from "../../../repositories/CameraEventRepository";
import useAlert from "../../../hooks/useAlert";

const ChangesPreview = ({ updateData, onCancel, onOk, onClose }) => {
  const { t } = useTranslation();
  const repository = new CameraEventRepository();
  const [changes, setChanges] = useState(null);

  const { showError } = useAlert();

  const handleCancel = () => {
    setChanges(null);
    if (onCancel) {
      onCancel();
    }
    if (onClose) {
      onClose();
    }
  };

  const handleApplyChanges = async () => {
    try {
      await repository.updateEvent(updateData);
      if (onOk) {
        onOk();
      }
      if (onClose) {
        onClose();
      }
    } catch (e) {
      showError(t("Error applying change. Please try again."));
    }
  };

  useEffect(async () => {
    const result = await repository.previewUpdateChanges(updateData);
    if (result.data.Paired.length > 0 || result.data.Unpaired.length > 0) {
      setChanges(result.data);
    } else {
      await handleApplyChanges();
    }
  }, []);

  return (
    <>
      {changes && (
        <DialogWindow
          changes={changes}
          onOk={handleApplyChanges}
          onCancel={handleCancel}
        />
      )}
    </>
  );
};

export default ChangesPreview;
